import {createSlice} from "@reduxjs/toolkit";
import axios from "axios";
import {AdminAPIUrl} from "../../GlobalVar";


const initialState = {
    projectsList: [], defaultProject: {},
}

const projectSlice = createSlice({
    name: 'projects', initialState, reducers: {
        async setProjectsList(state, action) {
            const payload = action.payload;
            const res = await axios({
                method: 'GET',
                url: AdminAPIUrl + '/project_list',
                headers: {"Authorization": `Bearer ${payload.authToken}`}
            })
            const projectList = []
            for (const dataKey in res.data) {
                projectList.push({key: dataKey, value: res.data[dataKey]});
            }
            state.projectsList.push(...projectList);
        }, setDefaultProject(state, action) {
            const payload = action.payload;
            state.defaultProject = payload.defaultProject;
        }
    }
});

export const {
    setProjectsList, setDefaultProject
} = projectSlice.actions;

export default projectSlice;